/* sk-search.js — quick-add for product cards on the search-results page.
   The reused sk-collection-card renders single-variant "+ Add" buttons as
   <button data-skc-add data-variant-id="…">. We intercept those inside
   .sk-search only, post to /cart/add.js, then refresh + open the site-wide
   cart drawer (sk-cart.js listens for sk-cart:refresh / sk-cart:open). */
(function () {
  "use strict";
  var root = document.querySelector("[data-sk-search]");
  if (!root) return;

  function add(btn) {
    var id = btn.getAttribute("data-variant-id");
    if (!id || btn.disabled) return;
    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = "Adding…";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error("add failed");
        return r.json();
      })
      .then(function () {
        btn.textContent = "Added ✓";
        document.dispatchEvent(new CustomEvent("sk-cart:refresh"));
        document.dispatchEvent(new CustomEvent("sk-cart:open"));
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 1200);
      })
      .catch(function (err) {
        console.error("Search quick-add failed:", err);
        btn.textContent = original;
        btn.disabled = false;
      });
  }

  root.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-skc-add]");
    if (!btn || !root.contains(btn)) return;
    e.preventDefault();
    add(btn);
  });
})();
